import { render } from "./myPage.vue?vue&type=template&id=1d82bf56&scoped=true&ts=true"
import script from "./myPage.vue?vue&type=script&lang=ts"
export * from "./myPage.vue?vue&type=script&lang=ts"

import "./myPage.vue?vue&type=style&index=0&id=1d82bf56&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d82bf56"]])

export default __exports__